















































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { ExTextLayer } from "@/model/document2/page/surface/design/layer/exTextLayer";
import { PlainTextLayer } from "@/model/document2/page/surface/design/layer/plainTextLayer";
import { MathHelper } from '@/helper/mathHelper';

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class TextShadowController extends Vue 
{
    @Prop() layer! : ExTextLayer;

    private getTextInfo(name : string)
    {
        if(this.layer.textInfoArray.length == 0) { return this.layer.baseTextInfo[name]; }
        var val = this.layer.textInfoArray[0][name];
        for(var i = 1; i < this.layer.textInfoArray.length; ++i)
        {
            var isEqual = false;
            var lastVal = this.layer.textInfoArray[i][name];            
            if(typeof(val) == "number")
            {
                if(MathHelper.equals(val, lastVal)) { isEqual = true; }
            }
            else
            {
                if(val == lastVal) { isEqual = true; }
            }
            if(!isEqual) { return null; }
        }

        return val;
    }

    private get shadowDistance()
    {
        var value = this.getTextInfo("shadowDistance");
        return value != null ? value : 10;
    }

    private set shadowDistance(shadowDistance)
    {
        this.changeTextInfo("shadowDistance", Number(shadowDistance), false, false);
    }

    private get shadowDistanceText()
    {
        return this.shadowDistance.toFixed() + "%";
    }

    private onShadowDistanceChanged()
    {
        this.changeTextInfo("shadowDistance", this.shadowDistance, true, false);
    }

    private get shadowRotate()
    {
        var value = this.getTextInfo("shadowRotate");
        return value != null ? value : 45;
    }

    private set shadowRotate(shadowRotate)
    {
        this.changeTextInfo("shadowRotate", Number(shadowRotate), false, false);
    }

    private get shadowRotateText()
    {
        return this.shadowRotate.toFixed();
    }

    private onShadowRotateChanged()
    {
        this.changeTextInfo("shadowRotate", this.shadowRotate, true, false);
    }


    private get shadowBlur()
    {
        var value = this.getTextInfo("shadowBlur");
        return value != null ? value : 50;
    }

    private set shadowBlur(shadowBlur)
    {
        this.changeTextInfo("shadowBlur", Number(shadowBlur), false, false);
    }

    private get shadowBlurText()
    {
        return this.shadowBlur.toFixed() + "%";
    }

    private onShadowBlurChanged()
    {
        this.changeTextInfo("shadowBlur", this.shadowBlur, true, false);
    }

    private get shadowIntensity()
    {
        var value = this.getTextInfo("shadowIntensity");
        return value != null ? value : 50;
    }

    private set shadowIntensity(shadowIntensity)
    {
        this.changeTextInfo("shadowIntensity", Number(shadowIntensity), false, false);
    }

    private get shadowIntensityText()
    {
        return this.shadowIntensity.toFixed() + "%";
    }

    private onShadowIntensityChanged()
    {
        this.changeTextInfo("shadowIntensity", this.shadowIntensity, true, false);
    }
    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }

    private changeTextInfo(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeTextInfo", propertyName, value, isFinish, isOnce);
    }
}
